<template>
  <div v-bar class="bar-out">
    <div infinite-wrapper>
      <b-list-group class="list-group-anim bg-white">
        <b-list-group-item
          v-for="energetic in list"
          :key="energetic.id"
          :class="[
            listTypeClass(energetic.typeID),
            { inactive: !!energetic.consumptionDateEnd },
          ]"
          :to="{ name: 'reportView', params: { energetics_id: energetic.id } }"
          class="flex-column align-items-start"
        >
          <div v-if="energetic.warnings" class="warning">
            {{ energetic.warnings }}
          </div>
          <div class="media">
            <div class="align-self-center mr-2">
              <b-badge
                v-if="energetic.powerNumber"
                class="badge-mw1 align-middle bg-power"
              >
                <icon class="icon-fw" name="plug" />
              </b-badge>
              <b-badge
                v-else-if="energetic.gasNumber"
                class="badge-mw1 align-middle bg-gas"
              >
                <icon class="icon-fw" name="fire" />
              </b-badge>
              <b-badge
                v-else-if="energetic.waterNumber"
                class="badge-mw1 align-middle bg-water"
              >
                <icon class="icon-fw" name="tint" />
              </b-badge>
              <b-badge
                v-else-if="energetic.heatNumber"
                class="badge-mw1 align-middle bg-heat"
              >
                <icon class="icon-fw" name="sun" />
              </b-badge>
            </div>
            <div class="media-body cl-hid">
              <h5 class="font-weight-bolder m-0">
                {{
                  energetic.powerNumber ||
                  energetic.gasNumber ||
                  energetic.waterNumber ||
                  energetic.heatNumber
                }}
              </h5>
              <div
                v-if="energetic.customer"
                class="font-weight-bold overflow-hidden"
                style="max-width: 250px; text-overflow: ellipsis"
              >
                {{ energetic.customer.name }}
              </div>
              <div
                v-if="energetic.localityName"
                class="fs-sm text-muted overflow-hidden"
                style="max-width: 250px; text-overflow: ellipsis"
              >
                {{ energetic.localityName }}
              </div>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
      <infinite-loading
        ref="infiniteLoading"
        force-use-infinite-wrapper="true"
        spinner="spiral"
        @infinite="infiniteHandler"
      >
        <template #spinner>
          <b-overlay :blur="null" class="my-4" opacity="0" show />
        </template>
        <div slot="no-results" class="nodata-container">
          <div class="text-center">
            <div class="mb-3">
              <b-icon font-scale="5" icon="question-diamond" />
            </div>
            <h2 class="mb-3">Žiadne dáta</h2>
          </div>
        </div>
        <div slot="no-more" />
      </infinite-loading>
    </div>
  </div>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'

export default {
  components: {
    InfiniteLoading,
  },
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    listTypeClass(e) {
      return {
        'list-power': e === 1,
        'list-gas': e === 2,
        'list-water': e === 3,
        'list-heat': e === 4,
      }
    },
    infiniteHandler($state) {
      this.$emit('loaded', true, $state)
    },
  },
}
</script>
